const initialState = {
  multiLanguageLabelsList: {},
};

export default function MultiLanguageReducer(state = initialState, action) {
  switch (action.type) {
    case "GET_ALL_LABELS":
      return { ...state, multiLanguageLabelsList: action.value };
    default:
      return state;
  }
}
